import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "@firebase/analytics";
const firebaseConfig = {
  apiKey: "AIzaSyDF_jhjfroJcHKKQe9WFuzVb6_7crGYMLM",
  authDomain: "project-state-courts.firebaseapp.com",
  databaseURL: "https://project-state-courts.firebaseio.com",
  projectId: "project-state-courts",
  storageBucket: "project-state-courts.appspot.com",
  messagingSenderId: "615025572229",
  appId: "1:615025572229:web:c57f2e9ece0f8e18fcecec",
  measurementId: "G-Z4QHRB6TH2",
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
// Utility function to log events
export const logAnalyticsEvent = (eventName, eventParams = {}) => {
  logEvent(analytics, eventName, eventParams);
};
export { analytics };
